// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Login from '../_raw/ui/icon_login.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Login);
